/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import moment from 'moment-timezone';

import ApiService from '../../Service/ApiService';
import TenantService from '../../Service/TenantService';
import { toastError, toastForTenant, toastOnTenantCreated } from '../../SweetAlertUtil/util';
import Loader from '../../Component/Common/Loader';
import PageHeader from '../Common/PageHeader';
import { withRouter } from 'react-router-dom';

const AppConfig = window.AppConfig;
const API_URLS = AppConfig.API_URLS;
const REGULAR_EXPRESSION = AppConfig.REGULAR_EXPRESSION;

function Form(props) { // NOSONAR
    const { handleSubmit, register, errors } = useForm();
    const onSubmit = async (values, e) => {
        try {
            setLoader(true);
            const requestBody = {
                full_name: values.fullName,
                min_interest_percentage: parseFloat(values.minInterest),
                max_interest_percentage: parseFloat(values.maxInterest),
                min_amount: parseFloat(values.minAmount),
                max_amount: parseFloat(values.maxAmount),
                max_pre_field_installment: parseInt(values.maxPreFieldInstallment),
                pre_field_installment_factor: parseFloat(values.preFieldInstallmentFactor),
                emi_service_fee: parseFloat(values.emiServiceFee),
                principal_service_fee: parseFloat(values.principalServiceFee),
                default_time_zone: Number((values.timeZone).replace(':', '.')),
                default_language: values.lang,
                default_currency: parseInt(values.currency),
                custom_field1: values.customField1,
                custom_field2: values.customField2,
                guarantor_response_time: parseInt(values.guarantorResponseTime)
            };
            if (props.match.params.id) {
                const editTenant = await TenantService.edit(props.match.params.id, requestBody);
                if (editTenant.status) {
                    toastForTenant('Tenant has been updated successfully.');
                } else {
                    toastError(editTenant.data);
                }
            } else {
                requestBody.short_name = (values.shortName).toLowerCase();
                const response = await TenantService.create(requestBody);
                let requestBodyForCopy = null;
                if (response.status) {
                    requestBodyForCopy = {
                        id: response.data.tenant.short_name,
                        name: response.data.tenant.full_name
                    };
                }
                await TenantService.createTenantOnCamunda(requestBodyForCopy);
                await TenantService.createCopyOfBpmnAndDeploy(response.data.tenant.id);
                if (response.status) {
                    const successMsg = `
                            Tenant has been successfully created. <br />
                            Tenant URL: <a target="_blank" href="https://${response.data.hostname}">${response.data.hostname}</a> <br />
                            It may take some time to reflect.                                
                        `;
                    toastOnTenantCreated(successMsg, () => {
                        e.target.reset();
                        props.history.push('/admin/tenants');

                    });
                } else {
                    toastError(response.data);
                }
            }
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.log(error);
        }

    };
    const [currency, setCurrency] = useState(null);
    const [language, setLanguage] = useState(null);
    const [timeZone, setTimeZone] = useState(null);
    const [isLoading, setLoader] = useState(false);
    const [minValue, setValues] = useState(0);
    const [minAmount, setMinAmount] = useState(0);
    const [defaultValues, setDefaultValues] = useState(null);
    
    useEffect(() => {
        if (props.match.params.id) {
            (async () => {
                setLoader(true);
                const response = await TenantService.getById(props.match.params.id);
                const values = {
                    fullName: response.full_name,
                    shortName: response.short_name,
                    minInterest: parseInt(response.min_interest_percentage),
                    maxInterest: parseInt(response.max_interest_percentage),
                    minAmount: parseInt(response.min_amount),
                    maxAmount: parseInt(response.max_amount),
                    maxPreFieldInstallment: parseInt(response.max_pre_field_installment),
                    preFieldInstallmentFactor: parseFloat(response.pre_field_installment_factor),
                    emiServiceFee: parseFloat(response.emi_service_fee),
                    principalServiceFee: parseFloat(response.principal_service_fee),
                    timeZone: response.default_time_zone,
                    lang: response.default_language,
                    currency: response.default_currency,
                    customField1: response.custom_field1,
                    customField2: response.custom_field2,
                    guarantorResponseTime: response.guarantor_response_time,
                };
                setDefaultValues(values);
                setLoader(false);
            })();
        }
        const timeZones = moment.tz.names();
        const timeZoneList = [];
        for (const time_Zone of timeZones) {
            timeZoneList.push({
                name: `${moment.tz(time_Zone).format('Z')} ${time_Zone}`,
                offset: moment.tz(time_Zone).format('Z')
            });
        }
        setTimeZone(timeZoneList);
        (async () => {
            const supportedtCurrency = await ApiService.GetData(API_URLS.CURRENCY, 'default', false);
            const supportedLanguage = await ApiService.GetData(API_URLS.LANGUAGE, 'default', false);
            setCurrency(supportedtCurrency);
            setLanguage(supportedLanguage);
        })();
    }, []);

    return (
        <>
            <PageHeader />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3
                                        className="card-title"
                                        style={{ marginLeft: '40%' }}>
                                        {props.match.params.id ? 'Edit A Tenant' : 'Add A Tenant'}
                                    </h3>
                                </div>

                                <form
                                    onSubmit={handleSubmit(onSubmit)}
                                // role="form"
                                >
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Full Name</label>
                                                    <input
                                                        className="form-control"
                                                        defaultValue={defaultValues !== null ? defaultValues.fullName : ''}
                                                        id="exampleInputEmail1"
                                                        name="fullName"
                                                        placeholder="Enter Full Name"
                                                        ref={register({
                                                            required: true
                                                        })}
                                                        type="string"
                                                    />
                                                    {errors.fullName && <p className="error">Full Name is required.</p>}
                                                </div>

                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputPassword1">Short Name</label>
                                                    <input
                                                        className="form-control"
                                                        defaultValue={defaultValues !== null ? defaultValues.shortName : ''}
                                                        disabled={!!props.match.params.id}
                                                        id="exampleInputPassword1"
                                                        name="shortName"
                                                        placeholder="Enter Short Name"
                                                        ref={register({
                                                            required: {
                                                                value: true,
                                                                message: 'Short Name is required.'
                                                            },
                                                            pattern: {
                                                                value: REGULAR_EXPRESSION.SHORT_NAME,
                                                                message: 'Short Name cannot have space or any special character'
                                                            }
                                                        })}
                                                        type="string"
                                                    />
                                                    {errors.shortName && <p className="error">{errors.shortName.message}</p>}
                                                </div>
                                            </div>

                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputPassword1">Min Interest Percentage</label>
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text">%</span>
                                                        </div>
                                                        <input
                                                            className="form-control"
                                                            defaultValue={defaultValues !== null ? defaultValues.minInterest : ''}
                                                            name="minInterest"
                                                            onChange={(e) => { setValues((e.target.value)); }}
                                                            placeholder="Enter Min Interest Percentage"
                                                            ref={register({
                                                                required: true
                                                            })}
                                                            type="number"
                                                        />
                                                    </div>
                                                    {errors.minInterest && <p className="error">Min Interest is required.</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputPassword1">Max Interest Percentage</label>
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text">%</span>
                                                        </div>
                                                        <input
                                                            className="form-control"
                                                            defaultValue={defaultValues !== null ? defaultValues.maxInterest : ''}
                                                            name="maxInterest"
                                                            placeholder="Enter Max Interest Percentage"
                                                            ref={register({
                                                                min: {
                                                                    value: minValue,
                                                                    message: 'Max Interest can not be less than min interest'
                                                                },
                                                                required: 'Max Interest is required.'
                                                            })}
                                                            type="number"
                                                        />
                                                    </div>
                                                    {errors.maxInterest && <p className="error">{errors.maxInterest.message}</p>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputPassword1">Min Amount</label>
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text">₱</span>
                                                        </div>
                                                        <input
                                                            className="form-control"
                                                            defaultValue={defaultValues !== null ? defaultValues.minAmount : ''}
                                                            name="minAmount"
                                                            onChange={(e) => { setMinAmount((e.target.value)); }}
                                                            placeholder="Enter Min Amount"
                                                            ref={register({
                                                                required: true
                                                            })}
                                                            type="number"
                                                        />
                                                    </div>
                                                    {errors.minAmount && <p className="error">Min Amount is required.</p>}
                                                </div>

                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputPassword1">Max Amount</label>
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text">₱</span>
                                                        </div>
                                                        <input
                                                            className="form-control"
                                                            defaultValue={defaultValues !== null ? defaultValues.maxAmount : ''}
                                                            name="maxAmount"
                                                            placeholder="Enter Max Amount"
                                                            ref={register({
                                                                min: {
                                                                    value: minAmount,
                                                                    message: 'Max Amount can not be less than min amount.'
                                                                },
                                                                required: 'Max Amount is required.'
                                                            })}
                                                            type="number"
                                                        />
                                                    </div>
                                                    {errors.maxAmount && <p className="error">{errors.maxAmount.message}</p>}
                                                </div>

                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputPassword1">Installment Factor</label>
                                                    <div className="input-group mb-3">
                                                        <input
                                                            className="form-control"
                                                            defaultValue={defaultValues !== null ? defaultValues.preFieldInstallmentFactor : ''}
                                                            name="preFieldInstallmentFactor"
                                                            placeholder="Enter Installment Factor"
                                                            ref={register({
                                                                min: {
                                                                    value: 0,
                                                                    message: 'Installment Factor can\'t be 0.'
                                                                },
                                                                required: 'Installment Factor is required.'
                                                            })}
                                                            step="any"
                                                            type="number"
                                                        />
                                                    </div>
                                                    {errors.preFieldInstallmentFactor && <p className="error">{errors.preFieldInstallmentFactor.message}</p>}
                                                </div>

                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputPassword1">Max Pre Filled Installment</label>
                                                    <div className="input-group mb-3">
                                                        <input
                                                            className="form-control"
                                                            defaultValue={defaultValues !== null ? defaultValues.maxPreFieldInstallment : ''}
                                                            name="maxPreFieldInstallment"
                                                            placeholder="Enter Max Pre Filled Installment"
                                                            ref={register({
                                                                min: {
                                                                    value: 0,
                                                                    message: 'Max Pre Filled Installment can\'t be 0.'
                                                                },
                                                                required: 'Max Pre Filled Installment is required.'
                                                            })}
                                                            type="number"
                                                        />
                                                    </div>
                                                    {errors.maxPreFieldInstallment && <p className="error">{errors.maxPreFieldInstallment.message}</p>}
                                                </div>

                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputPassword1">EMI Service Fee</label>
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text">%</span>
                                                        </div>
                                                        <input
                                                            className="form-control"
                                                            defaultValue={defaultValues !== null ? defaultValues.emiServiceFee : ''}
                                                            name="emiServiceFee"
                                                            placeholder="Enter EMI Service Fee"
                                                            ref={register({
                                                                required: true
                                                            })}
                                                            type="float"
                                                        />
                                                    </div>
                                                    {errors.emiServiceFee && <p className="error">EMI Service Fee is required.</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputPassword1">Principal Service Fee</label>
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text">%</span>
                                                        </div>
                                                        <input
                                                            className="form-control"
                                                            defaultValue={defaultValues !== null ? defaultValues.principalServiceFee : ''}
                                                            name="principalServiceFee"
                                                            placeholder="Enter Principal Service Fee"
                                                            ref={register({
                                                                required: true
                                                            })}
                                                            type="float"
                                                        />
                                                    </div>
                                                    {errors.principalServiceFee && <p className="error">Principal Service Fee is required.</p>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputPassword1">Custom Field 1</label>
                                                    <div className="input-group mb-3">
                                                        <input
                                                            className="form-control"
                                                            defaultValue={defaultValues !== null ? defaultValues.customField1 : ''}
                                                            name="customField1"
                                                            placeholder="Enter Custom Field 1"
                                                            ref={register}
                                                            type="string"
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputPassword1">Custom Field 2</label>
                                                    <div className="input-group mb-3">
                                                        <input
                                                            className="form-control"
                                                            defaultValue={defaultValues !== null ? defaultValues.customField2 : ''}
                                                            name="customField2"
                                                            placeholder="Enter Custom Field 2"
                                                            ref={register}
                                                            type="string"
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label>Time Zone</label>

                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><i className="far fa-clock" /></span>
                                                </div>
                                                <select
                                                    aria-hidden="true"
                                                    className="form-control select2 select2-hidden-accessible"
                                                    data-select2-id="1"
                                                    defaultValue={defaultValues !== null ? defaultValues.timeZone : ''}
                                                    name="timeZone"
                                                    ref={register}
                                                    style={{ width: '100%' }}
                                                    tabIndex="-1"
                                                >
                                                    {timeZone !== null ? timeZone.map((option, index) =>
                                                        (

                                                            <option
                                                                data-select2-id="1"
                                                                key={index}
                                                                selected="selected"
                                                                value={option.offset}
                                                            >{option.name}
                                                            </option>

                                                        )) : ''}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label>Default Language</label>
                                            <select
                                                aria-hidden="true"
                                                className="form-control select2 select2-hidden-accessible"
                                                data-select2-id="1"
                                                defaultValue={defaultValues !== null ? defaultValues.lang : ''}
                                                name="lang"
                                                ref={register}
                                                style={{ width: '100%' }}
                                                tabIndex="-1"
                                            >
                                                {language !== null ? language.map((option, index) =>
                                                    (

                                                        <option
                                                            data-select2-id="1"
                                                            key={index}
                                                            selected="selected"
                                                        >{option.locale}
                                                        </option>

                                                    )) : ''}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Default Currency</label>
                                            <select
                                                aria-hidden="true"
                                                className="form-control select2 select2-hidden-accessible"
                                                data-select2-id="1"
                                                defaultValue={defaultValues !== null ? defaultValues.currency : ''}
                                                name="currency"
                                                ref={register}
                                                style={{ width: '100%' }}
                                                tabIndex="-1"
                                            >
                                                {currency !== null ? currency.map((option, index) =>
                                                    (

                                                        <option
                                                            data-select2-id="1"
                                                            key={index}
                                                            selected="selected"
                                                            value={option.id}
                                                        >{option.short_name}
                                                        </option>

                                                    )) : ''}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                                    <label htmlFor="exampleInputPassword1">Guarantor Response Time</label>
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text">Hours</span>
                                                        </div>
                                                        <input
                                                            className="form-control"
                                                            defaultValue={defaultValues !== null ? defaultValues.guarantorResponseTime : ''}
                                                            name="guarantorResponseTime"
                                                            placeholder="Enter Guarantor Response Time (Hours)"
                                                            ref={register({
                                                                required: 'Guarantor Response Time is required.'
                                                            })}
                                                            type="number"
                                                        />
                                                    </div>
                                                    {errors.guarantorResponseTime && <p className="error">{errors.guarantorResponseTime.message}</p>}
                                                </div>
                                    </div>

                                    <div className="card-footer">
                                        <button
                                            className="btn btn-primary"
                                            style={{ marginLeft: '40%' }}
                                            type="submit"
                                        >Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                            {isLoading ? <Loader /> : ''}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default withRouter(Form);
